import React from 'react';
import { ControlLabel, FormControl, FormGroup, Panel } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import Select from 'react-select-plus';
import Switch from '../../shared/Switch';


const bidTypeOption = (bidType) => (
  <span>
    <FontAwesome name="square" style={{ color: bidType.color || '#fafafa' }} /> {bidType.value}
  </span>
);

const salespersonOption = ({ calendarColor, firstName, lastName }) => (
  <span>
    <FontAwesome name="square" style={{ color: calendarColor || '#fafafa' }} /> {`${firstName || ''} ${lastName || ''}`}
  </span>
);

const SearchForm = ({ customers, dropdowns, form, onCustomerSearch, onFormUpdate,datasheetsearch,onDatasheetSearchChange }) => 
{

if(datasheetsearch)
{
  return (
    
  <Panel defaultExpanded>
    <Panel.Toggle componentClass={Panel.Heading}>
    
      <Panel.Title toggle>
        <FontAwesome name="search" /> Search Datasheet/Customers
      </Panel.Title>      
    </Panel.Toggle>
    <Panel.Collapse>
      <Panel.Body>
      
        <FormGroup>
          <ControlLabel>Datasheet Name</ControlLabel>
          <FormControl onChange={(e) => onFormUpdate({ query: e.target.value })} value={form.query || ''} />
        </FormGroup>
        <FormGroup>
          <ControlLabel>Customer Name</ControlLabel>
          <FormControl onChange={(e) => onFormUpdate({ customerquery: e.target.value })} value={form.customerquery || ''} />
        </FormGroup>
       
        <FormGroup>
          <ControlLabel>Office</ControlLabel>
          <Select
            labelKey="name"
            multi
            options={dropdowns.offices}
            placeholder="All"
            value={form.offices}
            valueKey="id"
            onChange={(e) => onFormUpdate({ offices: e })}
          />
        </FormGroup>
        <FormGroup>
          <ControlLabel>Salesperson</ControlLabel>
          <Select
            multi
            labelKey="labelKey"
            optionRenderer={salespersonOption}
            options={dropdowns.salespeople}
            placeholder="All"
            value={form.salespeople}
            valueKey="id"
            valueRenderer={salespersonOption}
            onChange={(e) => onFormUpdate({ salespeople: e })}
          />
        </FormGroup>
      </Panel.Body>
    </Panel.Collapse>
  </Panel>
)}
else
{return (<Panel defaultExpanded>
    <Panel.Toggle componentClass={Panel.Heading}>
    
      <Panel.Title toggle>
        <FontAwesome name="search" /> Search Datasheet/Customers
      </Panel.Title>      
    </Panel.Toggle>
    <Panel.Collapse>
      <Panel.Body>
      
        <FormGroup>
          <ControlLabel>Customer Name</ControlLabel>
          <FormControl onChange={(e) => onFormUpdate({ query: e.target.value })} value={form.query || ''} />
        </FormGroup>       
       
        <FormGroup>
          <ControlLabel>Office</ControlLabel>
          <Select
            labelKey="name"
            multi
            options={dropdowns.offices}
            placeholder="All"
            value={form.offices}
            valueKey="id"
            onChange={(e) => onFormUpdate({ offices: e })}
          />
        </FormGroup>
        <FormGroup>
          <ControlLabel>Salesperson</ControlLabel>
          <Select
            multi
            optionRenderer={salespersonOption}
            options={dropdowns.salespeople}
            placeholder="All"
            value={form.salespeople}
            valueKey="id"
            valueRenderer={salespersonOption}
            onChange={(e) => onFormUpdate({ salespeople: e })}
          />
        </FormGroup>
      </Panel.Body>
    </Panel.Collapse>
  </Panel>
)
}
};

export default SearchForm;
